import React from 'react';
import { observer } from 'mobx-react-lite';
// import { applicationStore } from '@pascal/pascal-core/shared/core/store';
import GameContent from '../../containers/gameContent';
// import NonStopCashback from '../../components/nonStopCashback/index';
// import { cashbackStore } from '../../store/cashbackStore';
// import { EuroPopUps } from '../../components/euroTemplate/euroPopUp';

export const MobileGameMain = observer(() => {
  // const { isOpenCashbackPopup } = cashbackStore;
  // const { isDemo } = applicationStore;

  return (
    <div className='non-stop-match-mobile'>
      <GameContent />
      <div className='euro-cashback-popup'>
        {/* {!isDemo && isOpenCashbackPopup && <EuroPopUps />} */}
        {/* {!isDemo && <NonStopCashback />} */}
      </div>
    </div>
  );
});
